export default __webpack_public_path__ + "static/media/Docebo.d82fe2ff.svg";